import SelectBox from "./SelectBox";
import {
  CommonCodeGroupType,
  useGetCommonCodeGroupsByTypeAsAdminQuery,
} from "../../../lib/apollo/graphql/generated";
import { twMerge } from "tailwind-merge";

interface ActiveStatusSelectBoxProps {
  value: string;
  className?: string;
  onSelect: (value: string) => void;
}

export default function ActiveStatusSelectBox({
  value,
  onSelect,
  className,
}: ActiveStatusSelectBoxProps) {
  const { data } = useGetCommonCodeGroupsByTypeAsAdminQuery({
    variables: {
      types: [CommonCodeGroupType.Status],
    },
  });

  const status = data?.getCommonCodeGroupsByTypeAsAdmin?.filter(
    (item) => item.groupCode === CommonCodeGroupType.Status
  )[0];

  const options =
    status?.activeCommonCodes.map((code) => ({
      label: code.name,
      value: code.id,
    })) || [];

  return (
    <SelectBox
      label="활성 상태"
      value={value}
      options={options}
      onSelect={onSelect}
      className={twMerge("h-[50px]", className)}
    />
  );
}
